import {
  LIST_HEALTHCARE_SUPPORT_REQUEST,
  LIST_HEALTHCARE_SUPPORT_SUCCESS,
  LIST_HEALTHCARE_SUPPORT_FAIL,
  HEALTHCARE_SUPPORT_SUMMARY_REQUEST,
  HEALTHCARE_SUPPORT_SUMMARY_SUCCESS,
  HEALTHCARE_SUPPORT_SUMMARY_FAIL,
  DELETE_HEALTHCARE_SUPPORT_REQUEST,
  DELETE_HEALTHCARE_SUPPORT_SUCCESS,
  DELETE_HEALTHCARE_SUPPORT_FAIL,
  HEALTHCARE_SUPPORT_RESET,
  CREATE_HEALTHCARE_SUPPORT_DOCTOR_REQUEST,
  CREATE_HEALTHCARE_SUPPORT_DOCTOR_SUCCESS,
  CREATE_HEALTHCARE_SUPPORT_DOCTOR_FAIL,
  DETAIL_HEALTHCARE_SUPPORT_DOCTOR_REQUEST,
  DETAIL_HEALTHCARE_SUPPORT_DOCTOR_SUCCESS,
  DETAIL_HEALTHCARE_SUPPORT_DOCTOR_FAIL,
  UPDATE_HEALTHCARE_SUPPORT_DOCTOR_REQUEST,
  UPDATE_HEALTHCARE_SUPPORT_DOCTOR_SUCCESS,
  UPDATE_HEALTHCARE_SUPPORT_DOCTOR_FAIL,
  CREATE_HEALTHCARE_SUPPORT_NURSE_REQUEST,
  CREATE_HEALTHCARE_SUPPORT_NURSE_SUCCESS,
  CREATE_HEALTHCARE_SUPPORT_NURSE_FAIL,
  DETAIL_HEALTHCARE_SUPPORT_NURSE_REQUEST,
  DETAIL_HEALTHCARE_SUPPORT_NURSE_SUCCESS,
  DETAIL_HEALTHCARE_SUPPORT_NURSE_FAIL,
  UPDATE_HEALTHCARE_SUPPORT_NURSE_REQUEST,
  UPDATE_HEALTHCARE_SUPPORT_NURSE_SUCCESS,
  UPDATE_HEALTHCARE_SUPPORT_NURSE_FAIL,
  CREATE_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_REQUEST,
  CREATE_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_SUCCESS,
  CREATE_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_FAIL,
  DETAIL_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_REQUEST,
  DETAIL_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_SUCCESS,
  DETAIL_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_FAIL,
  UPDATE_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_REQUEST,
  UPDATE_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_SUCCESS,
  UPDATE_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_FAIL
} from '../../constants/healthcareSupports'

const initialState = {
  healthcareSupports: [],
  healthcareSupport: {},
  healthcareSupportsSummary: [],
  pageable: {},
  loading: false,
  error: ''
}

const healthcareSupportListReducer = (state = initialState, action) => {
  switch (action.type) {
    // ** Healthcare Support
    case LIST_HEALTHCARE_SUPPORT_REQUEST:
      return { ...state, loading: true }
    case LIST_HEALTHCARE_SUPPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        healthcareSupports: action.payload,
        pageable: action.pageable
      }
    case LIST_HEALTHCARE_SUPPORT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case HEALTHCARE_SUPPORT_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case HEALTHCARE_SUPPORT_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        healthcareSupportsSummary: action.payload
      }
    case HEALTHCARE_SUPPORT_SUMMARY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case DELETE_HEALTHCARE_SUPPORT_REQUEST:
      return { ...state, loading: true }
    case DELETE_HEALTHCARE_SUPPORT_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case DELETE_HEALTHCARE_SUPPORT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case HEALTHCARE_SUPPORT_RESET:
      return {
        ...state,
        loading: false,
        status: '',
        error: ''
      }

    // ** Healthcare Support - Doctor
    case CREATE_HEALTHCARE_SUPPORT_DOCTOR_REQUEST:
      return { ...state, loading: true }
    case CREATE_HEALTHCARE_SUPPORT_DOCTOR_SUCCESS:
      return {
        ...state,
        loading: false,
        pageable: action.pageable
      }
    case CREATE_HEALTHCARE_SUPPORT_DOCTOR_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case DETAIL_HEALTHCARE_SUPPORT_DOCTOR_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_HEALTHCARE_SUPPORT_DOCTOR_SUCCESS:
      return { ...state, loadingDetail: false, healthcareSupport: action.payload }
    case DETAIL_HEALTHCARE_SUPPORT_DOCTOR_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }

    case UPDATE_HEALTHCARE_SUPPORT_DOCTOR_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_HEALTHCARE_SUPPORT_DOCTOR_SUCCESS:

      return {
        ...state,
        loadingUpdate: false,
        pageable: action.pageable
      }
    case UPDATE_HEALTHCARE_SUPPORT_DOCTOR_FAIL:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload
      }

    // ** Healthcare Support - Nurse
    case CREATE_HEALTHCARE_SUPPORT_NURSE_REQUEST:
      return { ...state, loading: true }
    case CREATE_HEALTHCARE_SUPPORT_NURSE_SUCCESS:
      return {
        ...state,
        loading: false,
        healthcareSupports: action.payload
      }
    case CREATE_HEALTHCARE_SUPPORT_NURSE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case DETAIL_HEALTHCARE_SUPPORT_NURSE_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_HEALTHCARE_SUPPORT_NURSE_SUCCESS:
      return { ...state, loadingDetail: false, healthcareSupport: action.payload }
    case DETAIL_HEALTHCARE_SUPPORT_NURSE_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }

    case UPDATE_HEALTHCARE_SUPPORT_NURSE_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_HEALTHCARE_SUPPORT_NURSE_SUCCESS:

      return {
        ...state,
        loadingUpdate: false,
        pageable: action.pageable
      }
    case UPDATE_HEALTHCARE_SUPPORT_NURSE_FAIL:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload
      }

    // ** Healthcare Support - Laboratory Analyst
    case CREATE_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_REQUEST:
      return { ...state, loading: true }
    case CREATE_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_SUCCESS:
      return {
        ...state,
        loading: false,
        healthcareSupports: action.payload
      }
    case CREATE_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case DETAIL_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_SUCCESS:
      return { ...state, loadingDetail: false, healthcareSupport: action.payload }
    case DETAIL_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }

    case UPDATE_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_SUCCESS:

      return {
        ...state,
        loadingUpdate: false,
        pageable: action.pageable
      }
    case UPDATE_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_FAIL:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload
      }

    default:
      return state
  }
}

export default healthcareSupportListReducer
